import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ProgressValueDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        flexShrink: 1,
        minWidth: 0
    },
    value: {
        fontVariant: [
            "tabular-nums"
        ],
        flexShrink: 1
    }
});

export const useStyles = ({
    spaces
}: ProgressValueDynamicStyleType) => {
    const styles = {
        container: {
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
